import { debounceTime, filter, map, merge, mergeWith, Observable, pairwise } from 'rxjs';

export const ADS_SHOW = 'ads.show' as const;
export const LOG_ADS = 'log_ads' as const;
export const LOG_MISSING_AD = 'log_missing_ad' as const;
export const MEDIA_PAUSE = 'media.pause' as const;
export const MEDIA_PLAY = 'media.play' as const;

export function getLogAd$(
  pause$: Observable<unknown>,
  play$: Observable<unknown>,
  ad$: Observable<unknown>
) {
  const combined$ = merge(
    pause$.pipe(map(() => MEDIA_PAUSE)),
    play$.pipe(map(() => MEDIA_PLAY)),
    ad$.pipe(map(() => ADS_SHOW))
  );
  const PAUSE_TIMEOUT = 'pause.timeout';

  return combined$.pipe(
    mergeWith(
      combined$.pipe(
        filter(x => x === MEDIA_PAUSE),
        debounceTime(1500),
        map(() => PAUSE_TIMEOUT)
      )
    ),
    pairwise(),
    map(([acc, value]) => {
      if (value === ADS_SHOW && acc === MEDIA_PAUSE) {
        return LOG_ADS;
      }
      if (value === PAUSE_TIMEOUT && acc === MEDIA_PAUSE) {
        return LOG_MISSING_AD;
      }
      return null;
    }),
    filter(Boolean)
  );
}
